import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Bulk-fetch attachment counts for a list of parent records.
 * Returns a map: { "parent_type:parent_id": number }.
 *
 * Usage:
 *   const counts = useAttachmentCounts('appointment', appointments.map(a => a.id));
 *   counts[`appointment:${a.id}`] ?? 0
 */
export default function useAttachmentCounts(parentType, ids) {
    const [counts, setCounts] = useState({});

    // Stringify to give useEffect a stable dependency value
    const idsKey = (ids || []).join(',');

    useEffect(() => {
        const idList = (ids || []).filter(Boolean);
        if (!parentType || idList.length === 0) {
            setCounts({});
            return;
        }

        let cancelled = false;
        (async () => {
            try {
                const items = idList.map(id => ({ parent_type: parentType, parent_id: id }));
                const { data } = await axios.post(`${API_URL}/api/attachments/bulk-counts`, { items });
                if (!cancelled) setCounts(data.counts || {});
            } catch (e) {
                // Silent fail — badges are non-critical
                console.warn('Failed to fetch attachment counts', e);
            }
        })();

        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parentType, idsKey]);

    return counts;
}
